var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: `Notifications` },"tag":"div"}},[(_vm.numberOfNotifications > 0)?_c('span',{staticStyle:{"display":"flex","justify-content":"space-around"}},[_c('b',{staticClass:"notifNumber"},[_vm._v(_vm._s(_vm.numberOfNotifications))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }